import { render, staticRenderFns } from "./outlayCoin.vue?vue&type=template&id=aa92ac42&lang=pug&"
import script from "./outlayCoin.vue?vue&type=script&lang=js&"
export * from "./outlayCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports